import { Button, Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { EmptyState, RenderGuard, ErrorMessage } from 'components';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Account } from 'services';
import useErrorCatcher from 'utils/useErrorCatcher';
import { CardInfo } from './components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    paddingBottom: "0 !important"
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));
let mounted = false;

const AccountCards = props => {
  const { className, ...rest } = props;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const [models, setModels] = useState([]);
  const [card, setCard] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const model = useSelector(state => state.models.account);

  const classes = useStyles();

  const handleDeleteOpen = (card) => {
    if (mounted) {
      setOpenDelete(true);
      setCard(card);
    }
  };

  const handleDeleteClose = () => {
    if (mounted) {
      setOpenDelete(false);
      setCard(null);
    }
  };

  useEffect(() => {
    mounted = true;
    reload();
    return () => { mounted = false };
  }, []); // eslint-disable-line

  const reload = async () => {
    if (!model.id) return;
    setLoading(true);
    await runAsyncBlock(async () => {
      const response = await Account.stripe(model.id);
      setModels(response.model && response.model.stripe_cards ? response.model.stripe_cards : []);
    }).finally(() => mounted && setLoading(false));
  }
  if (!model) return;
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Account Cards" />
      <Divider />
      <RenderGuard renderIf={!loading}>
        <CardContent className={classes.content}>
          <Table>
            <TableBody>
              {models.map((card, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.header}>
                    <div>**** **** **** {card.extra1}</div>
                    <div><Typography variant="caption">{card.extra0}</Typography></div>
                  </TableCell>
                  <TableCell>
                    <div>{moment(card.created_at).format("DD/MM/YYYY")}</div>
                    <div><Typography variant="caption">Date added</Typography></div>
                  </TableCell>
                  <TableCell align="right">
                    <Button color="primary" onClick={() => handleDeleteOpen(card)} variant="outlined">
                      Delete
                  </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </RenderGuard>
      <ErrorMessage message={errorMessage} />
      <CardInfo onClose={handleDeleteClose} reload={reload} open={openDelete} model={card} />
      <EmptyState active={!models.length} message="This account has no cards added" />
    </Card>
  );
};

AccountCards.propTypes = {
  className: PropTypes.string,
};

export default AccountCards;
